export default __webpack_public_path__ + "static/media/food-mixer.3f5a143a.png";